module.exports = __webpack_public_path__ + "b7b73db1386d35e19448164d7f43e085.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-50@2x.png
// module id = 522
// module chunks = 0